(function($){

	$(document).ready(function(){
		
		if ("ontouchstart" in window || "ontouch" in window) { 

			$(document).on('click','.bubble-group .bubble',function(e){
				process_bubble_hover_click($(this));
			});

		} else {
			$('.bubble-group .bubble').hoverIntent(function() {
				process_bubble_hover_click($(this));
			});	
		}

		$('.bubble-group').hoverIntent(function() {
			
		},function(){
			$(this).find('.bubble.center').addClass('active').siblings().removeClass('active');
		});

		function process_bubble_hover_click($obj) {
			$obj.addClass('active').siblings().removeClass('active');
		}
		
		$(window).on('load resize orientationChange', function(event) { 
			init_bubble_slick();
		});
		

		function init_bubble_slick() {
			$('.bubble-mobile-slider').each(function(index){

				if(!$(this).hasClass('slick-initialized') && $(window).width() < 768) {

					$(this).slick({
				        slidesToShow: 1,
				        slidesToScroll: 1,
				        arrows: false,
				        dots: false,
				        infinite: false,
				        autoplay: false,
				        swipe: true,
				        centerMode: true,
				        mobileFirst: true,

						responsive: [
						    {
						      breakpoint: 768,
						      settings: "unslick"
						    }
					  	]
				    });
				}
			});
		}

	});
	
})(jQuery);